export enum SortingOrder {
    ALL,
    COMPLETE,
    NOT_COMPLETE
}